import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  consignmentBag,
  deactivateAgentConfigs,
  deleteAgentConfigs,
  deleteBagById,
  deleteChuteConfigs,
  deleteChuteConfigsBulkById,
  deleteChuteConfigsById,
  deleteWaybillByBagId,
  downloadAgents,
  downloadChuteById,
  editBags,
  editWaybillsbyBagId,
  exportBulkBag,
  exportMachineScans,
  getAgentConfigs,
  getBags,
  getBagsById,
  getChuteByIdTemplate,
  getChuteConfigs,
  getChuteConfigsById,
  getMachineScans,
  getSortingConfig,
  inScanBag,
  labelBag,
  moveConsignment,
  outScanBag,
  outScanBulkBag,
  outScanMachineScan,
  postAgentConfigs,
  postBags,
  postChuteByIdTemplate,
  postChuteConfigs,
  postChuteConfigsById,
  postWaybill,
  postWaybillByTemplate,
  printBag,
  putAgentConfigs,
  putChuteConfigs,
  putChuteConfigsById,
  receiveMachineScan,
  templateConsigment,
} from "../../services/SortingMachine/SortingServices";

const initialValues = {

};

let sortingPanelStore = (set) => ({
  ...initialValues,
  printBag: async (data) => {
    const response = await printBag(data);
    return response;
  },
  getBags: async (params) => {
    const response = await getBags(params);
    return response;
  },
  postBags: async (params) => {
    const response = await postBags(params);
    return response;
  },
  postWaybill: async (params, data) => {
    const response = await postWaybill(params, data);
    return response;
  },
  editBags: async (params, data) => {
    const response = await editBags(params, data);
    return response;
  },
  exportBulkBag: async (data) => {
    const response = await exportBulkBag(data);
    return response;
  },
  outScanBulkBag: async (data) => {
    const response = await outScanBulkBag(data);
    return response;
  },
  outScanBag: async (params) => {
    const response = await outScanBag(params);
    return response;
  },
  inScanBag: async (params) => {
    const response = await inScanBag(params);
    return response;
  },
  moveConsignment: async (params, data) => {
    const response = await moveConsignment(params, data);
    return response;
  },
  labelBag: async (params) => {
    const response = await labelBag(params);
    return response;
  },
  consignmentBag: async (params) => {
    const response = await consignmentBag(params);
    return response;
  },
  templateConsigment: async (params) => {
    const response = await templateConsigment(params);
    return response;
  },
  editWaybillsbyBagId: async (params1, params2, params3) => {
    const response = await editWaybillsbyBagId(params1, params2, params3);
    return response;
  },
  deleteBagById: async (params) => {
    const response = await deleteBagById(params);
    return response;
  },
  deleteWaybillByBagId: async (params1, params2) => {
    const response = await deleteWaybillByBagId(params1, params2);
    return response;
  },
  getChuteConfigs: async (params) => {
    const response = await getChuteConfigs(params);
    return response;
  },
  postChuteConfigs: async (data) => {
    const response = await postChuteConfigs(data);
    return response;
  },
  putChuteConfigs: async (params, data) => {
    const response = await putChuteConfigs(params, data);
    return response;
  },
  deleteChuteConfigs: async (params) => {
    const response = await deleteChuteConfigs(params);
    return response;
  },
  getChuteConfigsById: async (params1, params2) => {
    const response = await getChuteConfigsById(params1, params2);
    return response;
  },
  getBagsById: async (params1, params2) => {
    const response = await getBagsById(params1, params2);
    return response;
  },
  postWaybillByTemplate: async (params, data) => {
    const response = await postWaybillByTemplate(params, data);
    return response;
  },
  postChuteConfigsById: async (params, data) => {
    const response = await postChuteConfigsById(params, data);
    return response;
  },
  putChuteConfigsById: async (params, data) => {
    const response = await putChuteConfigsById(params, data);
    return response;
  },
  deleteChuteConfigsById: async (params1, params2) => {
    const response = await deleteChuteConfigsById(params1, params2);
    return response;
  },
  deleteChuteConfigsBulkById: async (params1, data) => {
    const response = await deleteChuteConfigsBulkById(params1, data);
    return response;
  },
  getChuteByIdTemplate: async () => {
    const response = await getChuteByIdTemplate();
    return response;
  },
  downloadChuteById: async (params) => {
    const response = await downloadChuteById(params);
    return response;
  },
  postChuteByIdTemplate: async (params, data) => {
    const response = await postChuteByIdTemplate(params, data);
    return response;
  },
  getAgentConfigs: async (params) => {
    const response = await getAgentConfigs(params);
    return response;
  },
  getMachineScans: async (params) => {
    const response = await getMachineScans(params);
    return response;
  },
  getSortingConfig: async (params) => {
    const response = await getSortingConfig(params);
    return response;
  },
  exportMachineScans: async (params) => {
    const response = await exportMachineScans(params);
    return response;
  },
  receiveMachineScan: async (params) => {
    const response = await receiveMachineScan(params);
    return response;
  },
  outScanMachineScan: async (params) => {
    const response = await outScanMachineScan(params);
    return response;
  },
  postAgentConfigs: async (data) => {
    const response = await postAgentConfigs(data);
    return response;
  },
  putAgentConfigs: async (params, data) => {
    const response = await putAgentConfigs(params, data);
    return response;
  },
  deleteAgentConfigs: async (params) => {
    const response = await deleteAgentConfigs(params);
    return response;
  },
  deactivateAgentConfigs: async (params, data) => {
    const response = await deactivateAgentConfigs(params, data);
    return response;
  },
  downloadAgents: async () => {
    const response = await downloadAgents();
    return response;
  },
});

sortingPanelStore = devtools(sortingPanelStore);

export const useSortingPanelStore = create(sortingPanelStore);
